var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "filter-container-content", attrs: { id: "cargoInfo" } },
    [
      _vm.titleFlag == ""
        ? _c("div", { staticClass: "filter-container-title" }, [
            _vm._v(_vm._s(_vm.$t("home.cargoInfo")) + "\n          "),
            _vm.isShowUnload
              ? _c(
                  "i",
                  {
                    staticClass: "el-icon-plus",
                    attrs: { hidden: _vm.preLockFlag || _vm.isDisable },
                    on: { click: _vm.handleAddFileCargo },
                  },
                  [_vm._v(_vm._s(_vm.$t("home.uploadFile")))]
                )
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.titleFlag == "2"
        ? _c("div", { staticClass: "filter-container-title" }, [
            _vm._v(_vm._s(_vm.$t("home.cargoInfoPrevious")) + "\n         "),
            _c(
              "i",
              {
                staticClass: "el-icon-plus",
                attrs: { hidden: _vm.preLockFlag || _vm.isDisable },
                on: { click: _vm.handleAddFileCargo },
              },
              [_vm._v(_vm._s(_vm.$t("home.uploadFile")))]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.titleFlag == "3"
        ? _c("div", { staticClass: "filter-container-title" }, [
            _vm._v(_vm._s(_vm.$t("home.cargoInfoCurrent")) + "\n         "),
            _c(
              "i",
              {
                staticClass: "el-icon-plus",
                attrs: { hidden: _vm.preLockFlag || _vm.isDisable },
                on: { click: _vm.handleAddFileCargo },
              },
              [_vm._v(_vm._s(_vm.$t("home.uploadFile")))]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "reqired",
                  class: _vm.inputClass("cargoDesc"),
                  attrs: { prop: "cargoDesc", label: _vm.$t("home.fwdDesc ") },
                },
                [
                  this.showCargoInfo
                    ? _c("light-input", {
                        staticClass: "cusInput",
                        attrs: {
                          "highlight-enabled": true,
                          "is-editable": !_vm.isDisable && !_vm.preLockFlag,
                          "max-length": 4000,
                        },
                        nativeOn: {
                          dblclick: function ($event) {
                            return _vm.handleDoubleClick(
                              _vm.form.cargoDesc,
                              1,
                              4000
                            )
                          },
                        },
                        model: {
                          value: _vm.form.cargoDesc,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "cargoDesc", $$v)
                          },
                          expression: "form.cargoDesc",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  class: [
                    _vm.inputClass("cargoShippingMark"),
                    { required: _vm.isShowRequired },
                  ],
                  attrs: {
                    prop: "cargoShippingMark",
                    label: _vm.$t("home.shippingMark "),
                  },
                },
                [
                  this.showCargoInfo
                    ? _c("light-input", {
                        staticClass: "cusInput",
                        attrs: {
                          "highlight-enabled": true,
                          "is-editable":
                            !_vm.isDisable &&
                            !(
                              _vm.preLockFlag &&
                              _vm.form.pol &&
                              _vm.form.pol === "CNDLC"
                            ),
                          "max-length": 4000,
                        },
                        nativeOn: {
                          dblclick: function ($event) {
                            return _vm.handleDoubleClick(
                              _vm.form.cargoShippingMark,
                              2,
                              4000
                            )
                          },
                        },
                        model: {
                          value: _vm.form.cargoShippingMark,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "cargoShippingMark", $$v)
                          },
                          expression: "form.cargoShippingMark",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  class: [
                    _vm.inputClass("cargoQuantity"),
                    { required: _vm.isShowRequired },
                  ],
                  attrs: {
                    prop: "cargoQuantity",
                    label: _vm.$t("home.packageCount"),
                  },
                },
                [
                  _c("el-input-number", {
                    attrs: {
                      precision: 0,
                      "auto-cut": true,
                      controls: false,
                      max: 99999999999999,
                      disabled: _vm.preLockFlag,
                    },
                    on: { blur: _vm.quantityToBoxInfo },
                    model: {
                      value: _vm.form.cargoQuantity,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "cargoQuantity",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.cargoQuantity",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticClass: "reqired cargoGrossWeight",
                  class: _vm.inputClass("cargoGrossWeight"),
                  attrs: {
                    prop: "cargoGrossWeight",
                    label: _vm.$t("home.actualGrossWeight "),
                  },
                },
                [
                  _c("el-input-number", {
                    attrs: {
                      precision: 3,
                      "auto-cut": true,
                      controls: false,
                      max: 99999999999.999,
                      disabled: _vm.preLockFlag,
                    },
                    on: { blur: _vm.weightToBoxInfo },
                    model: {
                      value: _vm.form.cargoGrossWeight,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "cargoGrossWeight",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.cargoGrossWeight",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.isShowRequired
                ? _c(
                    "el-form-item",
                    {
                      class: [_vm.inputClass("cargoSize"), "required"],
                      attrs: {
                        prop: "cargoSize",
                        label: _vm.$t("home.cntrSize "),
                      },
                    },
                    [
                      _c("el-input-number", {
                        attrs: {
                          precision: 3,
                          "auto-cut": true,
                          controls: false,
                          max: 99999999999.999,
                          disabled:
                            _vm.form.pol &&
                            _vm.form.pol === "CNDLC" &&
                            _vm.preLockFlag,
                        },
                        on: { blur: _vm.sizeToBoxInfo },
                        model: {
                          value: _vm.form.cargoSize,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form,
                              "cargoSize",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.cargoSize",
                        },
                      }),
                    ],
                    1
                  )
                : _c(
                    "el-form-item",
                    {
                      class: [_vm.inputClass("cargoSize")],
                      attrs: { label: _vm.$t("home.cntrSize ") },
                    },
                    [
                      _c("el-input-number", {
                        attrs: {
                          precision: 3,
                          "auto-cut": true,
                          controls: false,
                          max: 99999999999.999,
                          disabled:
                            _vm.form.pol &&
                            _vm.form.pol === "CNDLC" &&
                            _vm.preLockFlag,
                        },
                        model: {
                          value: _vm.form.cargoSize,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form,
                              "cargoSize",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.cargoSize",
                        },
                      }),
                    ],
                    1
                  ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                {
                  staticStyle: { visibility: "hidden" },
                  attrs: { label: _vm.$t("净重(KG)用于占位，不显示") },
                },
                [_c("el-input")],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  class: _vm.inputClass("cargoNetWeight"),
                  attrs: {
                    prop: "cargoNetWeight",
                    label: _vm.$t("home.imoNetWeight"),
                  },
                },
                [
                  _c("el-input-number", {
                    attrs: {
                      precision: 3,
                      "auto-cut": true,
                      controls: false,
                      max: 99999999999.999,
                      disabled: _vm.preLockFlag,
                    },
                    model: {
                      value: _vm.form.cargoNetWeight,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "cargoNetWeight",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.cargoNetWeight",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      !_vm.isShowOpen
        ? _c(
            "el-button",
            {
              staticClass: "openClick",
              attrs: { type: "text", disabled: false },
              on: { click: _vm.handleOpen },
            },
            [
              _vm._v(_vm._s(_vm.$t("home.expandOthers"))),
              _c("i", { staticClass: "el-icon-arrow-down" }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isShowOpen
        ? _c(
            "div",
            [
              _c(
                "el-button",
                {
                  staticClass: "openClick",
                  attrs: { type: "text", disabled: _vm.isShow },
                  on: { click: _vm.handleOpen },
                },
                [
                  _vm._v(_vm._s(_vm.$t("home.packUpOthers"))),
                  _c("i", { staticClass: "el-icon-arrow-up" }),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isShowOpen
        ? _c(
            "div",
            [
              _c(
                "el-row",
                { attrs: { gutter: 14 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "reqired",
                          class: _vm.inputClass("cargoPackageType"),
                          attrs: {
                            prop: "cargoPackageType",
                            label: _vm.$t("home.packageType"),
                          },
                        },
                        [
                          _c("glPackType", {
                            attrs: {
                              disabled:
                                _vm.form.pol &&
                                _vm.form.pol === "CNDLC" &&
                                _vm.preLockFlag,
                            },
                            on: { change: _vm.changePackage },
                            model: {
                              value: _vm.form.cargoPackageType,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "cargoPackageType", $$v)
                              },
                              expression: "form.cargoPackageType",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "reqired",
                          class: _vm.inputClass("cargoPackageDesc"),
                          attrs: {
                            prop: "cargoPackageDesc",
                            label: _vm.$t("home.packageDescOne"),
                          },
                        },
                        [
                          _c("el-input", {
                            directives: [
                              {
                                name: "byte-length",
                                rawName: "v-byte-length",
                                value: 50,
                                expression: "50",
                              },
                              { name: "uppercase", rawName: "v-uppercase" },
                            ],
                            attrs: {
                              onblur: "this.value = this.value.toUpperCase()",
                              disabled:
                                _vm.form.pol &&
                                _vm.form.pol === "CNDLC" &&
                                _vm.preLockFlag,
                            },
                            model: {
                              value: _vm.form.cargoPackageDesc,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "cargoPackageDesc", $$v)
                              },
                              expression: "form.cargoPackageDesc",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          class: _vm.inputClassTwo("commodityCode"),
                          attrs: {
                            prop: "commodityCode",
                            label: _vm.$t("home.commodityCode"),
                          },
                        },
                        [
                          _c("glCommodity", {
                            attrs: {
                              disabled:
                                _vm.preLockFlag ||
                                (_vm.form.pol && _vm.form.pol.startsWith("TH")),
                            },
                            on: { change: _vm.changeCom },
                            model: {
                              value: _vm.form.webBkCargoComs[0].commodityCode,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.form.webBkCargoComs[0],
                                  "commodityCode",
                                  $$v
                                )
                              },
                              expression:
                                "form.webBkCargoComs[0].commodityCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          class: [
                            {
                              reqired:
                                _vm.form.pol && _vm.form.pol.startsWith("TH"),
                            },
                            _vm.inputClass("commodityName"),
                          ],
                          attrs: {
                            rules: {
                              required:
                                _vm.form.pol && _vm.form.pol.startsWith("TH"),
                              message: _vm.$t("home.toast4"),
                              trigger: "blur",
                            },
                            prop: "commodityName",
                            label: _vm.$t("home.commodityNameOne"),
                          },
                        },
                        [
                          _c("el-input", {
                            directives: [
                              {
                                name: "byte-length",
                                rawName: "v-byte-length",
                                value: 500,
                                expression: "500",
                              },
                              { name: "uppercase", rawName: "v-uppercase" },
                              { name: "trim", rawName: "v-trim" },
                              { name: "fth", rawName: "v-fth" },
                            ],
                            attrs: {
                              onblur: "this.value = this.value.toUpperCase()",
                              disabled:
                                _vm.preLockFlag ||
                                (_vm.form.pol &&
                                  _vm.form.pol.startsWith("TH") &&
                                  !_vm.validateNull(_vm.form.commodityName) &&
                                  _vm.isMaterials),
                            },
                            model: {
                              value: _vm.form.commodityName,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "commodityName", $$v)
                              },
                              expression: "form.commodityName ",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 14 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          class: [
                            {
                              reqired:
                                _vm.form.pol && _vm.form.pol.startsWith("KR"),
                            },
                            _vm.inputClass("docCommodity"),
                          ],
                          attrs: {
                            prop: "docCommodity",
                            label: _vm.$t("home.docCommodity"),
                          },
                        },
                        [
                          _c("el-input", {
                            directives: [
                              {
                                name: "byte-length",
                                rawName: "v-byte-length",
                                value: 100,
                                expression: "100",
                              },
                              { name: "uppercase", rawName: "v-uppercase" },
                            ],
                            attrs: {
                              onblur: "this.value = this.value.toUpperCase()",
                              disabled: _vm.preLockFlag,
                            },
                            model: {
                              value: _vm.form.docCommodity,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "docCommodity", $$v)
                              },
                              expression: "form.docCommodity",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          class: [
                            {
                              reqired:
                                _vm.form.pol &&
                                (_vm.form.pol.startsWith("KR") ||
                                  (_vm.form.pol &&
                                    _vm.form.pol.startsWith("MY"))),
                            },
                            _vm.inputClass("hsCodeCn"),
                          ],
                          attrs: { prop: "hsCodeCn", label: "HS CODE" },
                        },
                        [
                          _c("el-input", {
                            directives: [
                              {
                                name: "byte-length",
                                rawName: "v-byte-length",
                                value: 8,
                                expression: "8",
                              },
                              { name: "uppercase", rawName: "v-uppercase" },
                            ],
                            attrs: {
                              onblur: "this.value = this.value.toUpperCase()",
                              disabled:
                                (_vm.form.pol &&
                                  _vm.form.pol === "CNDLC" &&
                                  _vm.preLockFlag) ||
                                (_vm.isMaterials &&
                                  _vm.form.pol &&
                                  _vm.form.pol.startsWith("MY")),
                            },
                            on: {
                              input: function ($event) {
                                _vm.form.hsCodeCn = _vm.form.hsCodeCn.replace(
                                  /[^\a-\z\A-\Z0-9\*\.]/g,
                                  ""
                                )
                              },
                            },
                            model: {
                              value: _vm.form.hsCodeCn,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "hsCodeCn", $$v)
                              },
                              expression: "form.hsCodeCn",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          class: [
                            {
                              reqired:
                                _vm.form.pol && _vm.form.pol.startsWith("KR"),
                            },
                            _vm.inputClass("hsCodeJp"),
                          ],
                          attrs: { prop: "hsCodeJp", label: "HS CODE(JP)" },
                        },
                        [
                          _c("el-input", {
                            directives: [
                              {
                                name: "byte-length",
                                rawName: "v-byte-length",
                                value: 6,
                                expression: "6",
                              },
                              { name: "uppercase", rawName: "v-uppercase" },
                            ],
                            attrs: {
                              onblur: "this.value = this.value.toUpperCase()",
                              disabled:
                                _vm.form.pol &&
                                _vm.form.pol === "CNDLC" &&
                                _vm.preLockFlag,
                            },
                            on: {
                              input: function ($event) {
                                _vm.form.hsCodeJp = _vm.form.hsCodeJp.replace(
                                  /[^\a-\z\A-\Z0-9\*\.]/g,
                                  ""
                                )
                              },
                            },
                            model: {
                              value: _vm.form.hsCodeJp,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "hsCodeJp", $$v)
                              },
                              expression: "form.hsCodeJp",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          class: [
                            {
                              reqired:
                                _vm.form.pol && _vm.form.pol.startsWith("KR"),
                            },
                            _vm.inputClass("hsCode"),
                          ],
                          attrs: { prop: "hsCode", label: "HS CODE(KR)" },
                        },
                        [
                          _c("el-input", {
                            directives: [
                              {
                                name: "byte-length",
                                rawName: "v-byte-length",
                                value: 20,
                                expression: "20",
                              },
                              { name: "uppercase", rawName: "v-uppercase" },
                            ],
                            attrs: {
                              onblur: "this.value = this.value.toUpperCase()",
                              disabled:
                                _vm.form.pol &&
                                _vm.form.pol === "CNDLC" &&
                                _vm.preLockFlag,
                            },
                            on: {
                              input: function ($event) {
                                _vm.form.hsCode = _vm.form.hsCode.replace(
                                  /[^\a-\z\A-\Z0-9\*\.]/g,
                                  ""
                                )
                              },
                            },
                            model: {
                              value: _vm.form.hsCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "hsCode", $$v)
                              },
                              expression: "form.hsCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("acceesoryCargo", {
        ref: "acceesoryCargo",
        attrs: {
          width: "50%",
          limitUpload: 1,
          bookingHeadWebId: _vm.form.bookingHeadWebComId,
        },
      }),
      _vm._v(" "),
      _c("msg-check-text-dialog", {
        ref: "myDialog",
        on: { confirm: _vm.confirm },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { color: "red", "margin-top": "20px" } }, [
      _c("i", { staticClass: "el-icon-warning" }),
      _vm._v("Forwarder guaranttees that Doc Commodity in correct"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }